// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import * as React from "react"; // Store Custom Code
import { css, useTheme } from "styled-components";

/* Starter Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import SizedWrapper, {
    sizedWrapperImageStyles,
    SizedWrapperStyles,
} from "@store/Library/Components/Toolkit/SizedWrapper";
import {
    headerHideForDesktopStyles,
    headerHideForMobileStyles,
    headerMobileSelector,
} from "@store/Themes/common/mixins/header";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import getValuesToBreakpoint from "@toolkit/Framework/Common/Utilities/getValuesToBreakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useHeaderPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Modal, { ModalPresentationProps } from "@store/MobiusOverrides/Modal/Modal";
import setChangeCustomerModalIsOpen from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/Handlers/ChangeCustomerIsOpen";
import React, { useEffect } from "react";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const enum fields {
    forceModalOpen = "forceModalOpen",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.forceModalOpen]: boolean;
    };
}

type Props = OwnProps & PageProps;

const itemSpacing = () => css`
    ${x => breakpointValues(x.theme.design.header.itemSpacing, "margin-right")}

    &:last-child {
        margin-right: 0;
    }
`;
/* Store Custom Code - End */

const zoneWrapperStyles = () => css`
    max-height: inherit;

    > div /* Zone */ {
        max-height: inherit;
    }
`;
/* Starter Custom Code - End */

export interface LogoLinksSearchStyles {
    /* Starter Custom Code - Start */
    sizedWrapper?: SizedWrapperStyles;
    wrapper?: InjectableCss;
    navWrapper?: InjectableCss;
    logoWrapper?: InjectableCss;
    searchWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    /* Starter Custom Code - End */
    // Store Custom Code
    navigationWrapper?: InjectableCss;
    desktopNavigationWrapper?: InjectableCss;
    changeCustomerModal?: ModalPresentationProps;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    sizedWrapper: {
        wrapper: {
            css: css`
                background-color: ${getColor("header")};
                color: ${getColor("header.contrast")};
                transform: translateZ(0);

                ${headerMobileSelector()} {
                    box-shadow: ${x => x.theme.shadows["1"] /* Store Custom Code */};
                }
            `,
        },
        content: {
            css: siteWidthStyles(),
        },
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-grow: 1;
            max-height: inherit;
            ${x => breakpointValues(x.theme.design.header.itemSpacing, "column-gap")}

            ${({ theme }) => {
                return breakpointValues(
                    getValuesToBreakpoint(
                        theme.design.header.iconButton.padding,
                        getPreviousBreakpoint(theme.design.header.breakpoint, theme),
                        theme,
                    ).map(x => (x ? `-${x}` : x)),
                    ["margin-right", "margin-left"],
                );
            }}

            /* Store Custom Code - Start */
            position: relative;
            /* Store Custom Code - End */
        `,
    },
    navWrapper: {
        css: css`
            ${headerHideForDesktopStyles()}
            ${zoneWrapperStyles()}
            flex-grow: 1;
        `,
    },
    logoWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            ${sizedWrapperImageStyles()}
            flex-shrink: 0;
        `,
    },
    searchWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            /* Store Custom Code - Start */
            ${itemSpacing()}
            /* Store Custom Code - End */
            flex-grow: 1;
            max-width: none; /* Store Custom Code */
        `,
    },
    contentWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            /* Store Custom Code - Start */
            ${itemSpacing()}
	        /* Store Custom Code - End */

            > div /* Zone */ {
                display: flex;
                align-items: center;
                ${x => breakpointValues(x.theme.design.header.subItemSpacing, "column-gap")}
            }
        `,
    },
    /* Store Custom Code - Start */
    desktopNavigationWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            ${zoneWrapperStyles()}
            ${itemSpacing()}
            flex-grow: 0;
        `,
    },
    navigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-grow: 2;

            ${headerMobileSelector()} {
                flex-grow: 0;
            }
        `,
    },
    /* Store Custom Code - End */
};

const styles = logoLinksSearchStyles; // Starter Custom Code

const LogoLinksSearch: React.FC<Props> = ({ id, fields /* Store Custom Code */ }) => {
    /* Starter Custom Code - Start */
    const headerPage = useHeaderPage();
    const theme = useTheme();

    /* Store Custom Code - Start */
    const dispatch = useAppDispatch();
    const changeCustomerModalIsOpen = useAppSelector(state => state.greif.components.changeCustomerModal.isOpen);
    const modalCloseHandler = () => dispatch(setChangeCustomerModalIsOpen({ isOpen: false }));

    useEffect(() => {
        setChangeCustomerModalIsOpen({ isOpen: fields.forceModalOpen });
    }, []);
    /* Store Custom Code - End */

    return (
        <>
            <SizedWrapper
                heights={theme.design.header.height} // Store Custom Code
                paddings={theme.design.header.padding} // Store Custom Code
                extendedStyles={styles.sizedWrapper}
            >
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.navWrapper} data-zone-single>
                        <Zone contentId={id} zoneName="Navigation" /* Store Custom Code */ />
                    </StyledWrapper>
                    <StyledWrapper {...styles.logoWrapper} data-zone-single>
                        <Zone contentId={id} zoneName="Logo" /* Store Custom Code */ />
                    </StyledWrapper>
                    <StyledWrapper {...styles.navigationWrapper} /* Store Custom Code */>
                        {/* Store Custom Code - Start */}
                        <StyledWrapper {...styles.desktopNavigationWrapper} data-zone-single>
                            <Zone contentId={id} zoneName="Navigation" />
                        </StyledWrapper>
                        {/* Store Custom Code - End */}
                        <StyledWrapper {...styles.searchWrapper} data-zone-single>
                            <Zone contentId={id} zoneName="Search" />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contentWrapper}>
                            <Zone contentId={id} zoneName="Content" />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </SizedWrapper>
            {/* Store Custom Code - Start */}
            <Modal
                {...styles.changeCustomerModal}
                headline={translate("Change Account")}
                isOpen={changeCustomerModalIsOpen}
                handleClose={modalCloseHandler}
            >
                <Zone zoneName="ChangeAccount" contentId={id} />
            </Modal>
            {/* Store Custom Code - End */}
        </>
    );
    /* Starter Custom Code - End */
};

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        allowedContexts: ["Header"], // Starter Custom Code
        /* Store Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.forceModalOpen,
                displayName: "Force Modal Open",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
        /* Store Custom Code - End */
    },
};

export default logoLinksSearch;
